import MobileAppModalAlertSettingsPage from './MobileAppModalAlertSettingsPage';

export default MobileAppModalAlertSettingsPage;
